// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 创建推广事件 POST /ad-event/trace/upload */
export async function adEventTraceUploadUsingPOST(
  body: API.AdEventTraceUploadReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/ad-event/trace/upload', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
